import { toast as sonnerToast } from 'sonner';
import { showAppError } from '../lib/appErrorBanner';

type ToastOptions = {
  variant?: 'default' | 'destructive';
  title?: string;
  description?: string;
};

/**
 * Success / info → sonner. Errors → fixed bottom banner (Paper 2XH-style), same title/description API.
 */
function toast(options: ToastOptions) {
  const { variant = 'default', title = '', description } = options;
  if (variant === 'destructive') {
    showAppError(title || 'Error', description);
  } else {
    sonnerToast(title || undefined, { description: description ?? undefined });
  }
}

export { toast };
